/**
 * Calculate the Shop by cash down dropdown option values
 * @param minDown
 */
export function getDownPaymentDropdownOptions(minDown?: number): number[] {
  if (minDown === undefined) return [];

  const downPaymentOptions: number[] = [minDown];
  const next1000 = Math.ceil((minDown + 1) / 1_000) * 1_000;

  return downPaymentOptions.concat(
    Array.from(Array(4).keys()).map(n => n * 1_000 + next1000)
  );
}

/**
 * Calculate the Shop by monthly payment dropdown option values
 * @param maxMonthly
 */
export function getMonthlyPaymentDropdownOptions(
  maxMonthly?: number
): number[] {
  if (maxMonthly === undefined) return [];

  const monthlyOptions: number[] = [];

  for (let i = maxMonthly < 700 ? 100 : 300; i <= maxMonthly; i += 100) {
    monthlyOptions.push(i);
  }

  return monthlyOptions;
}
